import { ArrowDownIcon, ArrowUpIcon, ChevronUpDownIcon } from '@heroicons/react/24/outline';

import { SortState } from '../../types';

export const SortIndicator = ({ sortState, columnKey }: { sortState?: SortState; columnKey: string }) => {
  const isSorted = sortState?.key === columnKey;

  if (!isSorted) {
    return <ChevronUpDownIcon className="ml-1 size-4 text-gray-400" />;
  }

  return sortState.direction === 'asc' ? (
    <ArrowUpIcon className="ml-1 size-4 text-gray-700" />
  ) : (
    <ArrowDownIcon className="ml-1 size-4 text-gray-700" />
  );
};
